import { AbstractControl } from '@angular/forms';

type AllOrNoneOpts = {
  errorKey?: string;
  ignoreDisabled?: boolean;
};

type ControlWithName = { name: string; ctrl: AbstractControl };

export const allOrNoneValidator = (controlNames: string[], groupName: string, opts: AllOrNoneOpts = {}) => {
  const { errorKey = 'coRequired', ignoreDisabled = true } = opts;
  const isEmpty = (v: unknown) => v === null || v == undefined || (typeof v === 'string' && v.trim() === '');

  return (group: AbstractControl) => {
    const ctrls = controlNames
      .map((name) => ({ name, ctrl: group.get(name) }))
      .filter((ctrl) => !!ctrl.ctrl) as ControlWithName[];

    if (ctrls.length !== controlNames.length) return null;

    const consider = ignoreDisabled ? ctrls.filter((c) => c?.ctrl.enabled) : ctrls;
    const empties = consider.filter((c) => isEmpty(c.ctrl.value));
    const allEmpty = empties.length === consider.length;
    const nonEmpty = empties.length === 0;

    if (allEmpty || nonEmpty) {
      consider.forEach((c) => {
        if (c?.ctrl.errors?.[errorKey]) {
          const { ...rest } = c!.ctrl.errors;
          c?.ctrl.setErrors(Object.keys(rest).length ? rest : null);
        }
      });
      return null;
    }

    for (const { name, ctrl } of empties) {
      ctrl.setErrors({
        ...(ctrl.errors ?? {}),
        [errorKey]: { requiredWithGroup: controlNames.filter((n) => n !== name), groupName },
      });
    }
    return { allOrNone: true };
  };
};
